import { REDUX_DOMAIN_LIST_SECTION_KEY } from '@gymaholic/packages'

const PROFILE_LOGS_DOMAIN = 'profileLogs'

const PROFILE_LOGS_ACTION = {
  CREATE_NEW: 'PROFILE_LOGS_CREATE_NEW',
  CREATE: 'PROFILE_LOGS_CREATE',
  DELETE: 'PROFILE_LOGS_DELETE',
  LOAD: 'PROFILE_LOGS_LOAD',
  SAVE: 'PROFILE_LOGS_SAVE'
}

const PROFILE_LOGS_ROOT = '/profile-logs'

const PROFILE_LOGS_ENDPOINT = {
  ROOT: PROFILE_LOGS_ROOT
}

const PROFILE_LOGS_KEY = {
  ALL: 'all',
  CURRENT: 'current',
  DATA: 'data'
}

const PROFILE_LOGS_PATH = {
  ALL: `${PROFILE_LOGS_DOMAIN}.${PROFILE_LOGS_KEY.ALL}`,
  ALL_DATA: `${PROFILE_LOGS_DOMAIN}.${PROFILE_LOGS_KEY.ALL}.data`,
  BY_PROFILE_ID: `${PROFILE_LOGS_DOMAIN}.${REDUX_DOMAIN_LIST_SECTION_KEY.BY_PROFILE_ID}`,
  CURRENT: `${PROFILE_LOGS_DOMAIN}.${PROFILE_LOGS_KEY.CURRENT}`,
  DATA: `${PROFILE_LOGS_DOMAIN}.${PROFILE_LOGS_KEY.DATA}`
}

export {
  PROFILE_LOGS_DOMAIN,
  PROFILE_LOGS_ACTION,
  PROFILE_LOGS_ENDPOINT,
  PROFILE_LOGS_KEY,
  PROFILE_LOGS_PATH
}
